import React, {useEffect, useState} from "react";
import IMG from "../../constants/image";
import {useLocation} from "react-router-dom";
import {LinkApp, PATH} from "../../constants";
import {isAndroid, isMobile} from "react-device-detect";


const DownloadApp = () => {
    const location = useLocation();
    const {pathname} = location || {}


    const handleRedirect = () => {
        if (isAndroid)
            return window.open(LinkApp.ANDROID, '_blank');
        return window.open(LinkApp.IOS, '_blank');
    }
    if (!isMobile || window?.ReactNativeWebView) return null;
    if (pathname !== PATH.LOGIN) return null;

    return (
        <div
            className={`bg-gradient-to-r from-[#0D9A52] via-[#187F55] to-[#128D53] opacity-100 translate-y-0 flex justify-between items-center px-4 space-x-3 w-full py-[10px]`}
        >
            <div className="flex items-center space-x-4" aria-label="Home">
                <img
                    className='w-10 h-10'
                    src={IMG.logoFuNong}
                    alt="logo funong"
                />
                <div className="text-white">
                    <div className="text-xs font-bold">Tải ứng dụng FUTA FuNong</div>
                    <div className="text-[10px]">Sàn Thương Mại Điện Tử Nông Nghiệp</div>
                </div>
            </div>
            <button className="bg-white inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 shadow hover:bg-primary/90 h-9 py-2 text-black rounded-2xl px-3" onClick={handleRedirect}>
                Tải ngay
            </button>
        </div>
    )
}

export default DownloadApp;